import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UserlistModel } from "../../../../model/jubili/user-manage/get-users";

type ResetPasswordStep = "confirm" | "result" | "error";

@Component({
    selector: "bo-jub-reset-password-modal",
    templateUrl: "./reset-password-modal.component.html",
    styleUrls: ["./reset-password-modal.component.scss"]
})

export class ResetPasswordModalComponent {

    constructor(
        private modalService: NgbModal
    ) { }

    @ViewChild("content") content: any;
    @Output() confirmEvent = new EventEmitter<string>();

    step: ResetPasswordStep = "confirm";
    targetEmail: string = "";
    targetFullName: string = "";
    targetCompanyName: string = "";
    targetUserSurrKey: number = 0;
    newPassword: string = "";
    errorMessage: string = "";
    copied: boolean = false;
    // กันกดยืนยันซ้ำระหว่างรอ response - reset ซ้ำจะได้รหัสใหม่อีกตัว
    // ทำให้รหัสที่ CS เพิ่งอ่านให้ลูกค้าใช้ไม่ได้
    isSubmitting: boolean = false;

    private ngbModalRef: NgbModalRef;

    // เปิดหน้ายืนยัน - ยังไม่ยิง API จนกว่า CS จะกดยืนยัน
    // รับทั้ง row เพราะ CS ยืนยันตัวลูกค้าด้วยชื่อ/บริษัท ไม่ใช่อีเมลอย่างเดียว
    openConfirm(user: UserlistModel): void {
        this.step = "confirm";
        this.targetEmail = user.userEmail;
        this.targetFullName = ((user.userName || "") + " " + (user.userSurName || "")).trim();
        this.targetCompanyName = user.companyName;
        this.targetUserSurrKey = user.userSurrKey;
        this.newPassword = "";
        this.errorMessage = "";
        this.copied = false;
        this.isSubmitting = false;

        // backdrop static กัน CS เผลอคลิกนอก modal ตอนรหัสใหม่ค้างอยู่บนจอ
        this.ngbModalRef = this.modalService.open(this.content, {
            centered: true,
            backdrop: "static",
            windowClass: "rp-modal-window"
        });
    }

    confirm(): void {
        // กดซ้ำระหว่างรอ response ไม่มีผล
        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        this.confirmEvent.emit(this.targetEmail);
    }

    // เรียกจาก parent เมื่อ API ตอบ 200
    showResult(newPassword: string): void {
        this.isSubmitting = false;
        this.step = "result";
        this.newPassword = newPassword;
    }

    // เรียกจาก parent เมื่อ API ตอบ error
    showError(message: string): void {
        this.isSubmitting = false;
        this.step = "error";
        this.errorMessage = message;
    }

    copyPassword(): void {
        const input = document.createElement("textarea");
        input.value = this.newPassword;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);

        this.copied = true;
    }

    close(): void {
        if (this.ngbModalRef) {
            this.ngbModalRef.close();
        }
    }
}
